import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Tabs, Tab, Button, Offcanvas, Form } from 'react-bootstrap';
import transaction from "../../actions/transaction";
import {ReactComponent as InfoSvg} from './../../assets/icons/svg/info.svg';
import {ReactComponent as UserSvg} from './../../assets/icons/svg/user.svg';
import {ReactComponent as KeySvg} from './../../assets/icons/svg/keys.svg';
import ListPickup from "../../components/ListPickup";
import { toast } from 'react-toastify';
import moment from 'moment';
import auths from "../../actions/auth";
import master from "../../actions/master";


export default function ProfileForm() {
  const dataUser = JSON.parse(sessionStorage.getItem('profile'));
  const formRef = useRef();
  const navigate = useNavigate();
  const [auth, setAuth] = useState([]);
  const [prov, setProv] = useState([]);
  const [cities, setCitites] = useState([]);
  const [district, setDistrict] = useState([]);
  const [village, setVillage] = useState([]);
  const [partner, setPartner] = useState([]);
  const [showResp, setShowResp] = useState(false);
  const handleCloseResp = () => setShowResp(false);
  const handleShowResp = () => setShowResp(true);
  const [form, setForm] = useState({
      nama: dataUser?.name,
      no_handphone: dataUser?.phone,
      email: dataUser?.email,
      provinces: dataUser?.province_id,
      cities: dataUser?.city_id,
      district: dataUser?.district_id,
      villages: dataUser?.village_id,
      address: dataUser?.address,
      jumlah_keluarga: dataUser?.total_family_member,
   });

   useEffect(() => {
      if(!dataUser || dataUser.name === ''){
         navigate('/profile')
      }
      master.actions.get_province().then((res) => {
         setProv(res.data);
      });
      master.actions.get_cities(dataUser?.province_id).then((res) => {
         setCitites(res.data);
      });
      master.actions.get_district(dataUser?.city_id).then((res) => {
         setDistrict(res.data);
      });
      master.actions.get_village(dataUser?.district_id).then((res) => {
         setVillage(res.data);
      });
  },[]);

   const changeProvince = (d) =>{
      setForm({...form, ...{provinces: d, cities: '', district: '', villages: ''}})
      master.actions.get_cities(d).then((res) => {
         setCitites(res.data);
      });
   }

   const changeCities = (d) =>{
      setForm({...form, ...{cities: d,  district: '', villages: ''}})
      master.actions.get_district(d).then((res) => {
         setDistrict(res.data);
      });
   }

   const changeDistrict = (d) =>{
      setForm({...form, ...{district: d, villages: ''}})
      master.actions.get_village(d).then((res) => {
         setVillage(res.data);
      });
   }

   const changeVillage = (d) =>{
      setForm({...form, ...{villages: d}})
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      let data = {
         name: form?.nama,
         phone: form?.no_handphone,
         email: form?.email,
         address: form?.address,
         province_id: form?.provinces,
         city_id: form?.cities,
         district_id: form?.district,
         village_id: form?.villages,
         total_family_member: form?.jumlah_keluarga
      }
      auths.actions.put_profile(data).then((res) => {
         toast.success('Profil berhasil di edit');
         navigate('/profile')
      }).catch((err) => {
         toast.success('Gagal mengedit profil');
      });
   }

   const onBack = () => {
      if(dataUser.name !== ''){
         navigate('/profile', {state: {edit: true}})
      }
   }

   
  return (
   <div className="bg-light">
       <div className="fixed-top header bg-light">
         <div className="text-center fw-semibold">
               Edit Profile
         </div>
         <Button className="btn btn-icon btn-success btn-sm btn-radius btn-nav-back" onClick={() => onBack()}>
               <i className="ph-arrow-left text-light"></i>
         </Button>
      </div>

      <Form onSubmit={(e) => handleSubmit(e)} ref={formRef}>  
         <div className="px-4 content-height pt-5 mt-5 bg-light">
            <Form.Group className="mb-3">
               <Form.Label className="mb-2">Nama*</Form.Label>
               <Form.Control type="text" placeholder="Nama" defaultValue={form.nama} onChange={(e) => setForm({...form, ...{nama: e.target.value}})} required/>
            </Form.Group>
            <Form.Group className="mb-3">
               <Form.Label className="mb-2">No. Handphone (WhatsApp)*</Form.Label>
               <Form.Control type="number" placeholder="No. handphone (WA)" defaultValue={form.no_handphone} onChange={(e) => setForm({...form, ...{no_handphone: e.target.value}})} required/>
            </Form.Group>
            <Form.Group className="mb-3">
               <Form.Label className="mb-2">Email</Form.Label>
               <Form.Control type="email" placeholder="Email" defaultValue={form.email} onChange={(e) => setForm({...form, ...{email: e.target.value}})}/>
               <small className="text-smooth ts-sm"><i>Jika tidak mempunyai email, kosongkan email</i></small>
            </Form.Group>
            <Form.Group className="mb-3">
               <Form.Label className="mb-2">Provinsi*</Form.Label>
               <Form.Select 
                  size="sm" 
                  value={form.provinces} 
                  onChange={(e) => changeProvince(e.target.value)}
                  required
               >
                  <option value=''>Pilih</option>
                  { prov && prov.map((e, key) => {
                        return <option value={e.code} key={key}>{e.name}</option>
                     })
                  }
               </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
               <Form.Label className="mb-2">Kota/Kabupaten*</Form.Label>
               <Form.Select 
                  size="sm" 
                  disabled={form.provinces === ''} 
                  value={form.cities} 
                  onChange={(e) => changeCities(e.target.value)}
                  required
               >
                  <option value='' selected={form.provinces === ''}>Pilih</option>
                  { cities && cities.map((e, key) => {
                        return <option value={e.code} key={key}>{e.name}</option>
                     })
                  }
               </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
               <Form.Label className="mb-2">Kecamatan*</Form.Label>
               <Form.Select 
                  size="sm" 
                  disabled={form.cities === '' || form.provinces === ''} 
                  value={form.district} 
                  onChange={(e) => changeDistrict(e.target.value)}
                  required
               >
                  <option value='' selected={form.cities === '' || form.provinces === ''}>Pilih</option>
                  { district && district.map((e, key) => {
                        return <option value={e.code} key={key}>{e.name}</option>
                     })
                  }
               </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
               <Form.Label className="mb-2">Kelurahan/Desa*</Form.Label>
               <Form.Select 
                  size="sm" 
                  disabled={form.district === '' || form.cities === '' || form.provinces === ''} 
                  value={form.villages} 
                  onChange={(e) => changeVillage(e.target.value)}
                  required
               >
                  <option value='' selected={form.district === '' || form.cities === '' || form.provinces === ''}>Pilih</option>
                  { village && village.map((e, key) => {
                        return <option value={e.code} key={key}>{e.name}</option>
                     })
                  }
               </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
               <Form.Label className="mb-2">Alamat Kantor*</Form.Label>
               <textarea placeholder="Tulis alamat detail" className="form-control" rows={5} onChange={(e) => setForm({...form, ...{address: e.target.value}})} value={form?.address} required></textarea>
            </Form.Group>
            <Form.Group className="mb-3">
               <Form.Label className="mb-2">Jumlah Anggota Keluarga yg tinggal bersama*</Form.Label>
               <Form.Control type="number" size="sm" value={form.jumlah_keluarga} className="bg-white" placeholder="Jumlah orang" onChange={(e) => setForm({...form, ...{jumlah_keluarga: e.target.value}})} required/>
            </Form.Group>
         </div>

         <div className="btn-fixed-btm">
            <div className="d-flex justify-content-between align-items-center w-100 px-4">
               <Button type="button" className="rounded-pill py-2 me-3 w-50 d-flex align-items-center justify-content-center" variant="success-opacity" onClick={() => navigate('/profile')}>
                  Batalkan
               </Button>
               <Button type="submit" className="rounded-pill py-2 w-50" variant="success">
                  Simpan
               </Button>
            </div>
         </div>
      </Form>
      
      <Offcanvas show={showResp} onHide={handleCloseResp} placement="bottom" className="h-auto">
         <Offcanvas.Header>
            <Offcanvas.Title className="w-100">
               <div className="d-flex align-items-center justify-content-between">
                  Detail Profile
                  <small className="text-success px-2">Edit</small>
               </div>
            </Offcanvas.Title>
         </Offcanvas.Header>
         <Offcanvas.Body className="py-5">
            <table className="table-listed">
               <tbody>
                  <tr>
                     <td className="w-50 text-muted">Nama</td>
                     <td className="w-50 fw-semibold text-end">{auth?.name}</td>
                  </tr>
                  <tr>
                     <td className="w-50 text-muted">Email</td>
                     <td className="w-50 fw-semibold text-end">{auth?.email}</td>
                  </tr>
                  <tr>
                     <td className="w-50 text-muted">Jenis Nasabah</td>
                     <td className="w-50 fw-semibold text-end">{auth?.type === 'person' ? 'Perorangan':'Non-Perorangan'}</td>
                  </tr>
                  <tr>
                     <td className="w-50 text-muted">No Handphone</td>
                     <td className="w-50 fw-semibold text-end">{auth?.phone}</td>
                  </tr>
                  <tr>
                     <td className="w-50 text-muted">Jumlah Anggota Kelurga yang tinggal bersama</td>
                     <td className="w-50 fw-semibold text-end">{auth?.total_family_member}</td>
                  </tr>
                  <tr>
                     <td className="w-50 text-muted">Mitra Terdaftar</td>
                     <td className="w-50 fw-semibold text-end">
                        {auth.partners && auth.partners.map((data, keys)=>{
                           return <span key={keys}>{data?.name} {keys+1 !== auth?.partners?.length ? ', ' : ''}</span>
                        })}
                     </td>
                  </tr>
                  <tr>
                     <td className="w-50 text-muted">Tanggal Terdaftar</td>
                     <td className="w-50 fw-semibold text-end">{moment(new Date(auth?.created_at)).format('DD/MM/YYYY')}</td>
                  </tr>
                  <tr>
                     <td className="w-50 text-muted">Alamat Rumah</td>
                     <td className="w-50 fw-semibold text-end">{auth?.address + ', ' + auth?.village?.name+ ', ' + auth?.district?.name+ ', ' + auth?.city?.name+ ', ' + auth?.province?.name}</td>
                  </tr>
               </tbody>
            </table>
         </Offcanvas.Body>
      </Offcanvas>
   </div>
  );
}